export {default} from '../../../core/components/DataManagement/DataManagementDetailListOfValues';